import type { TrackingEvent } from './trackPayload';

export const trackingData: unique symbol = Symbol('tracking data');

export type TrackingData = {
  /**
   * Event to track to amplitude when this action is dispatched.
   *
   * Event types and payloads are declared in `TrackingEventRegistry`.
   */
  [trackingData]?: TrackingEvent;
};

export type Trackable<T extends object | undefined = undefined> =
  T extends undefined ? TrackingData : T & TrackingData;
